<template>
  <multiselect
    :filterable="true"
    :options="options"
    v-model="selected"
    :custom-label="label"
    :placeholder="placeholder" />
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    draw: {
      type: Number,
    },
    placeholder: {
      type: String
    },
    value: {
      type: Object
    },
    taxTypeID: {
      type: Number,
    },
    taxID: {
      type: Number,
    }
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/master/sub-tax",
      options: [],
      selected: (this.multiple) ? [] : null
    };
  },
  methods: {
    get() {
      if (this.taxTypeID && this.taxID) {
        this.$http
          .get(this.baseUrl, {
            params: {
              order: "name",
              sort: "asc",
              tax_id: this.taxID,
              tax_type_id: this.taxTypeID,
            }
          })
          .then(resp => {
            if (resp.code === 200) {
              resp.data.records.map(function (x) {
                return (x.label = x.group_code + " - " + x.name);
              });

              this.options = resp.data.records;
            } else {
              this.options = []
              console.log(resp.data);
            }
          });
      }
    },
    label(option) {
      return option.label;
    },
  },
  watch: {
    taxID() { this.get(); },
    taxTypeID() { this.get(); },

    selected(newVal) {
      this.$emit("selected", newVal);
    }
  },
  mounted() {
    this.get();
  }
};
</script>
